// @ts-check
// Situações e motivos dos bots, das execuções e dos passos (contrato de bots, seção 8.2). Puros; os textos ficam no
// namespace `bots` (parte da frente das telas dos bots) e os motivos de fim e de passo na parte do motor dos bots.

export const BOT_STATUSES = Object.freeze(/** @type {const} */ (['DRAFT', 'ACTIVE', 'INACTIVE']));
export const BOT_INACTIVE_REASONS = Object.freeze(/** @type {const} */ ([
  'MANUAL', 'OWNER_UNAVAILABLE', 'PERMISSION_DENIED', 'CHANNEL_REMOVED', 'MODULE_DISABLED', 'SUBSCRIPTION_CANCELED',
]));
export const BOT_RUN_STATUSES = Object.freeze(/** @type {const} */ ([
  'RUNNING', 'WAITING_INPUT', 'WAITING_EFFECT', 'COMPLETED', 'HANDED_OFF', 'TIMED_OUT', 'STOPPED', 'FAILED',
]));
/** Execuções abertas: no máximo uma por conversa (índice único parcial de bot_run). */
export const OPEN_BOT_RUN_STATUSES = Object.freeze(/** @type {const} */ (['RUNNING', 'WAITING_INPUT', 'WAITING_EFFECT']));
export const CLOSED_BOT_RUN_STATUSES = Object.freeze(/** @type {const} */ (['COMPLETED', 'HANDED_OFF', 'TIMED_OUT', 'STOPPED', 'FAILED']));
export const BOT_END_REASONS = Object.freeze(/** @type {const} */ ([
  'END_NODE', 'END_OF_PATH', 'HANDOFF', 'TIMEOUT', 'WINDOW_CLOSED', 'HUMAN_TOOK_OVER', 'STOP_KEYWORD', 'MANUAL_STOP', 'BOT_DEACTIVATED',
  'BOT_DELETED', 'MODULE_DISABLED', 'RESTORED', 'LOOP_LIMIT', 'ERROR', 'LEGAL_RESTRICTION', 'RESTRICTED_TICKET',
]));
export const BOT_STEP_STATUSES = Object.freeze(/** @type {const} */ (['PASSED', 'SKIPPED', 'INVALID', 'TIMEOUT', 'FAILED']));
/** Motivos de passo pulado ou com falha (o passo nunca guarda texto, só o caminho e os nomes dos campos gravados). */
export const BOT_STEP_REASONS = Object.freeze(/** @type {const} */ ([
  'NOTHING_TO_CHANGE', 'OPTION_NOT_FOUND', 'FIELD_NOT_WRITABLE', 'PERMISSION_DENIED', 'NOT_TEXT', 'TOO_SHORT', 'TOO_LONG', 'NOT_A_NUMBER',
  'OUT_OF_RANGE', 'INVALID_EMAIL', 'INVALID_CPF', 'INVALID_DATE', 'INVALID_PHONE', 'INVALID_CEP', 'NO_MATCH', 'NO_FILE', 'WINDOW_CLOSED',
  'INTEGRATION_FAILED', 'INTEGRATION_TIMEOUT', 'RECORD_NOT_FOUND', 'TEAM_RESTRICTED', 'LOOP_LIMIT', 'ERROR',
  // a pessoa pediu atendente no meio de um bloco: o bloco passa (PASSED) com este motivo
  'HUMAN_REQUESTED',
]));
/** Estado da conversa enquanto um bot conduz (message_thread.bot_state). */
export const BOT_THREAD_STATES = Object.freeze(/** @type {const} */ (['BOT', 'HUMAN']));
/** Por que a execução espera para seguir (bot_run.resume_kind); BOOKING é a chamada à página de agendamento, feita fora da transação. */
export const BOT_RESUME_KINDS = Object.freeze(/** @type {const} */ (['REMINDER', 'TIMEOUT', 'EFFECT', 'BOOKING']));
